// @ vendor
const Immutable = require('immutable');
const moment = require('moment');

// @ utilities
const IbanHelper = require('utilities/ibanHelper');
const { generateAccountId } = require('utilities/APIParsingHelper');

// @ constants
const { PAYMENT_TYPE, FLOW_STEPS, TYPEOFROADS: { OTHERS, UNKNOWN } } = require('../../insuranceConstants/insuranceRequestHome');
const {
    INSURANCE_REQUEST_WIZARD_LOAD_STEP,
    INSURANCE_REQUEST_WIZARD_VALIDATE_STEP,
    INSURANCE_REQUEST_WIZARD_SET_VISIBLE_STEP,
    INSURANCE_REQUEST_WIZARD_SET_DATA,
    INSURANCE_REQUEST_PRICING_REQUEST,
    INSURANCE_REQUEST_PRICING_SUCCESS,
    INSURANCE_REQUEST_PRICING_FAILURE,
    INSURANCE_REQUEST_PROVINCES_REQUEST,
    INSURANCE_REQUEST_PROVINCES_SUCCESS,
    INSURANCE_REQUEST_PROVINCES_FAILURE,
    INSURANCE_REQUEST_SET_PAYMENT_ACCOUNT_REQUEST,
    INSURANCE_REQUEST_SET_PAYMENT_ACCOUNT_SUCCESS,
    INSURANCE_REQUEST_SET_PAYMENT_ACCOUNT_FAILURE,
    INSURANCE_REQUEST_GET_MORTGAGE_BANK_LIST,
    INSURANCE_REQUEST_GET_MORTGAGE_BANK_LIST_SUCCESS,
    INSURANCE_REQUEST_GET_MORTGAGE_BANK_LIST_FAILURE,
    INSURANCE_REQUEST_GET_PAYMENT_ACCOUNT_REQUEST,
    INSURANCE_REQUEST_GET_PAYMENT_ACCOUNT_SUCCESS,
    INSURANCE_REQUEST_GET_PAYMENT_ACCOUNT_FAILURE,
    INSURANCE_REQUEST_SAVE_STEP_REQUEST,
    INSURANCE_REQUEST_SAVE_STEP_SUCCESS,
    INSURANCE_REQUEST_SAVE_STEP_FAILURE,
    INSURANCE_REQUEST_GET_ADDRESS_TYPE_LIST_IN_PROGRESS,
    INSURANCE_REQUEST_GET_ADDRESS_TYPE_LIST_SUCCESS,
    INSURANCE_REQUEST_GET_ADDRESS_TYPE_LIST_FAILURE,
} = require('../../insuranceConstants/actionTypes');

const { typeOfInputs, validationsForInputs } = require('../../insuranceConstants/insuranceRequestHomeAddress');

const setInitialState = () => {
    return Immutable.Map().merge({
        valid: false,
        validUI: false,
        fieldErrors: false,
        paymentType: '',
        startDate: '',
        hasMortgage: false,
        mortgageBank: '',
        mortgageBankList: [],
        accountId: null,
        totalCost: null,
        accountBalance: 0,
        enoughAccountBalance: false,
        accountIBAN: null,
        setPaymentAccountInProgress: false,
        isFetchingAddressTypeList: false,
        isFetchingAccount: false,
        isSaving: false,
        roadType: '',
        roadTypeName: '',
        addressTypeList: [],
        road: '',
        number: '',
        additionalInfo: '',
        population: '',
        provinceId: '',
        provinces: {},
        isFetchingProvinces: false,
        isFetchingMortgageBankList: false,
        pricing: {},
        isFetchingPricing: false,
        errorMortgageBankList: false,
        errorPricing: '',
        errorSave: '',
        errorPayment: '',
        errorProvinces: '',
        shouldValidateAdditionalInfo: false
    });
};

const validateInputsValue = (value, key) => {
    const validation = validationsForInputs[key].match.test(value)
    return validation;
}

const validateAccountBanlance = (accountId, accountBalance, totalCost, startDate) => {
    const diffDays = moment(startDate).diff(moment().startOf('day'), 'days');
    if( diffDays === 0){
        return !!accountId && totalCost !== null && accountBalance >= totalCost;
    } else {
        return true;
    }
}

const validateStep = step => {
    const accountId = step.get('accountId');
    const accountBalance = step.get('accountBalance');
    const totalCost = step.get('totalCost');
    const startDate = step.get('startDate');
    const accountValidation = validateAccountBanlance(accountId, accountBalance, totalCost, startDate);
    const road = step.get('road');
    const isRoadValid = !!road ? validateInputsValue(road, typeOfInputs.road) : false;
    const roadType = step.get('roadType');
    const isRoadTypeValid = !!roadType ? validateInputsValue(roadType, typeOfInputs.roadType) : false;
    const population = step.get('population');
    const number = step.get('number');
    const isNumberValid = number ? validateInputsValue(number, typeOfInputs.number) : false;
    const additionalInfo = step.get('additionalInfo');
    const isAdditionalInfoValid = validateInputsValue(additionalInfo, typeOfInputs.additionalInfo);
    const addressValidation = !!isRoadTypeValid && !!isRoadValid && !!isNumberValid && !!population && !!isAdditionalInfoValid;
    const hasMortgage = step.get('hasMortgage');
    const mortgageBank = step.get('mortgageBank');
    const mortgageValidation = hasMortgage && mortgageBank || !hasMortgage;
    const isFetchingPricing = step.get('isFetchingPricing');
    const validateAdditionalInfo = step.get('shouldValidateAdditionalInfo') ? additionalInfo : true;
    const validUI = !isFetchingPricing && !!startDate && accountValidation && addressValidation && mortgageValidation && validateAdditionalInfo && accountId;
    return step.merge({
        validUI,
        fieldErrors: true
    });
};

const insuranceRequestWizardStep4 = (state = setInitialState(), action) => {
    switch (action.type) {
        case INSURANCE_REQUEST_WIZARD_VALIDATE_STEP:
            return validateStep(state);

        case INSURANCE_REQUEST_WIZARD_LOAD_STEP:
            const {
                home: {
                    roadType,
                    road,
                    number,
                    additionalInfo,
                    hasMortgage,
                    mortgageBank,
                    provinceId,
                    population
                },
                payment: { paymentType },
                flowData: { uiStep },
                startDate
            } = action.data;

            return state.merge({
                roadType: state.get('roadType') || roadType,
                road: state.get('road') || road,
                number: state.get('number') || number,
                provinceId: provinceId || state.get('provinceId'),
                population: population || state.get('population'),
                additionalInfo: state.get('additionalInfo') || additionalInfo,
                paymentType: state.get('paymentType') || paymentType || PAYMENT_TYPE.ANNUAL,
                startDate: state.get('startDate') || startDate,
                hasMortgage: state.get('hasMortgage') || !!hasMortgage,
                mortgageBank: state.get('mortgageBank') || mortgageBank,
                valid: FLOW_STEPS[uiStep] > FLOW_STEPS.STEP_4,
                errorSave: ''
            });

        case INSURANCE_REQUEST_WIZARD_SET_VISIBLE_STEP:
            return state.merge({
                valid: false,
                fieldErrors: false
            });

        case INSURANCE_REQUEST_WIZARD_SET_DATA:
            return state.merge({
                ...action.data,
                validUI: false,
                valid: false
            });

        case INSURANCE_REQUEST_PRICING_REQUEST:
            return state.merge({
                isFetchingPricing: true,
                fieldErrors: false,
                errorPricing: ''
            });

        case INSURANCE_REQUEST_PRICING_SUCCESS:
            return state.mergeDeep({
                pricing: action.data,
                isFetchingPricing: false
            });

        case INSURANCE_REQUEST_PRICING_FAILURE:
            return state.merge({
                errorPricing: action.data.error,
                isFetchingPricing: false
            });

        case INSURANCE_REQUEST_PROVINCES_REQUEST:
            return state.merge({
                isFetchingProvinces: true,
                errorProvinces: ''
            });

        case INSURANCE_REQUEST_PROVINCES_SUCCESS:
            return state.merge({
                provinces: action.data,
                isFetchingProvinces: false
            });

        case INSURANCE_REQUEST_PROVINCES_FAILURE:
            return state.merge({
                errorProvinces: action.data.error,
                isFetchingProvinces: false
            });

        case INSURANCE_REQUEST_SET_PAYMENT_ACCOUNT_REQUEST:
            return state.merge({
                setPaymentAccountInProgress: true,
                errorPayment: ''
            });
        case INSURANCE_REQUEST_SET_PAYMENT_ACCOUNT_SUCCESS:
            return state.merge({
                setPaymentAccountInProgress: false
            });
        case INSURANCE_REQUEST_SET_PAYMENT_ACCOUNT_FAILURE:
            return state.merge({
                setPaymentAccountInProgress: false,
                errorPayment: action.data.error
            });
        case INSURANCE_REQUEST_GET_MORTGAGE_BANK_LIST:
            return state.merge({
                isFetchingMortgageBankList: true,
                errorMortgageBankList: false
            });
        case INSURANCE_REQUEST_GET_MORTGAGE_BANK_LIST_SUCCESS:
            return state.merge({
                isFetchingMortgageBankList: false,
                mortgageBankList: action.data.bankList,
                errorMortgageBankList: false
            });
        case INSURANCE_REQUEST_GET_MORTGAGE_BANK_LIST_FAILURE:
            return state.merge({
                isFetchingMortgageBankList: false,
                mortgageBankList: [],
                errorMortgageBankList: true
            });
        case INSURANCE_REQUEST_GET_PAYMENT_ACCOUNT_REQUEST:
            return state.merge({
                isFetchingAccount: true,
                errorPayment: ''
            });
        case INSURANCE_REQUEST_GET_PAYMENT_ACCOUNT_SUCCESS:
            let accountId = state.get('accountId');
            let accountIBAN = state.get('accountIBAN');

            if (action.data && action.data.account) {
                accountIBAN = action.data.account;
                const ibanComplex = IbanHelper.getIbanComplexObject(accountIBAN);
                accountId = generateAccountId({
                    country: ibanComplex.pais,
                    controlDigit: ibanComplex.digitodecontrol,
                    codbban: ibanComplex.codbban
                });
            }

            return state.merge({
                accountId,
                accountIBAN,
                isFetchingAccount: false
            });
        case INSURANCE_REQUEST_GET_PAYMENT_ACCOUNT_FAILURE:
            return state.merge({
                isFetchingAccount: false,
                errorPayment: action.data.error
            });

        case INSURANCE_REQUEST_GET_ADDRESS_TYPE_LIST_IN_PROGRESS:
            return state.merge({
                isFetchingAddressTypeList: true
            });

        case INSURANCE_REQUEST_GET_ADDRESS_TYPE_LIST_SUCCESS:
            let addressTypeList = state.get('addressTypeList');
            let roadTypeName = '';
            if (action.data) {
                addressTypeList = action.data

                const addressTypeData = addressTypeList.data;
                const roadType = state.get('roadType');
                const roadNameSearch = addressTypeData.filter(road => {
                    return road.languageKey === roadType
                })
                const isRoadTypeNameInvalid = roadType === UNKNOWN || roadType === OTHERS;
                roadTypeName = roadNameSearch.length === 0 || isRoadTypeNameInvalid ? '' : roadNameSearch[0].name;
            }
            return state.merge({
                addressTypeList,
                roadTypeName,
                isFetchingAddressTypeList: false
            });


        case INSURANCE_REQUEST_GET_ADDRESS_TYPE_LIST_FAILURE:
            return state.merge({
                setPaymentAccountInProgress: false
            });

        case INSURANCE_REQUEST_SAVE_STEP_REQUEST:
            return state.merge({
                isSaving: true,
                errorSave: ''
            });
        case INSURANCE_REQUEST_SAVE_STEP_SUCCESS:
            return state.merge({
                isSaving: false,
                valid: !action.data.onlyUpdate
            });
        case INSURANCE_REQUEST_SAVE_STEP_FAILURE:
            return state.merge({
                isSaving: false,
                errorSave: action.data.error
            });

        default:
            return state;
    }
};

module.exports = insuranceRequestWizardStep4;
